export const ANALYTICS_EVENT_PAGE_VIEWED = 'Page Viewed';
export const ANALYTICS_EVENT_USER_SESSION = 'User Session';
export const ANALYTICS_EVENT_LOGO_CLICK = 'Logo Click';
export const ANALYTICS_EVENT_ROOMMATE_SIGNUP = 'Roommate Signup';
export const ANALYTICS_EVENT_GUARANTOR_SIGNUP = 'Guarantor Signup';
export const ANALYTICS_EVENT_LEAD_FORM_COMPLETED = 'Lead Form Completed';
export const ANALYTICS_EVENT_SHOWING_ADDED_TO_TOUR = 'Showing Added To Tour';
export const ANALYTICS_EVENT_SHOWING_REMOVED_BY_USER = 'Showing Removed By User';
export const ANALYTICS_EVENT_SHOWING_MARKED_AS_FAILED_BY_CS = 'Showing Marked As Failed By CS';
export const ANALYTICS_EVENT_SHOWING_MARKED_AS_FAILED_BY_ONFLEET = 'Showing Marked As Failed By Onfleet'; // eslint-disable-line max-len
export const ANALYTICS_EVENT_TEXT_AGENT_BUTTON_CLICK = 'Button Click: Text Agent';
export const ANALYTICS_EVENT_SEARCH_FILTERS_UPDATED = 'Search Filters Updated';
export const ANALYTICS_EVENT_SUGGESTED_SEARCH_FILTERS_CLICK = 'Suggested Search Filters Click';
export const ANALYTICS_EVENT_LISTING_PHOTO_CLICK = 'Listing Photo Click';
export const ANALYTICS_EVENT_LISTING_BOOKMARKED = 'Listing Bookmarked';
export const ANALYTICS_EVENT_LISTING_REMOVED_FROM_BOOKMARK = 'Listing Removed From Bookmark';
export const ANALYTICS_EVENT_TOUR_STATUS_UPDATE = 'Tour Status Update';
export const ANALYTICS_EVENT_APPLICATION_STATUS_UPDATE = 'Application Status Update';
export const ANALYTICS_EVENT_SECURITY_DEPOSIT_PAID = 'Security Deposit Paid';
export const ANALYTICS_EVENT_SECURITY_DEPOSIT_PAYMENT_INITIATED = 'Security Deposit Payment Initiated';
export const ANALYTICS_EVENT_SECURITY_DEPOSIT_PAYMENT_FAILED = 'Security Deposit Payment Failed';
export const ANALYTICS_EVENT_CALL_BUTTON = 'Call Button in Listing Page';
export const ANALYTICS_EVENT_USER_PHONE_CONFIRMED = 'User Phone Confirmed';
export const ANALYTICS_EVENT_HOUSEHOLD_USER_REMOVED = 'Household User Removed';
export const ANALYTICS_EVENT_CLICKED_NON_MATCHED_HOMES = 'Non-matched Homes List Expanded';
export const ANALYTICS_EVENT_SMS_LISTING_PREQUAL_CONFIRM = 'User Confirms Listing Prequalifications';
export const ANALYTICS_EVENT_MAP_SEARCHED = 'Map Searched';
export const ANALYTICS_EVENT_ADDRESS_SEARCHED = 'Address Searched';
export const ANALYTICS_EVENT_USER_SETTINGS_UPDATE = 'User Settings Update';
export const ANALYTICS_EVENT_STREET_VIEW_CLICK = 'Street View Click';
export const ANALYTICS_EVENT_APARTMENT_LOCATOR_CONTACT_BUTTON_CLICK = 'Apartment Locator Contact Button Click'; // eslint-disable-line max-len
export const ANALYTICS_EVENT_APARTMENT_LOCATOR_CHECK_AVAILABILITY_BUTTON_CLICK = 'Apartment Locator Check Availability Button Click'; // eslint-disable-line max-len
export const ANALYTICS_EVENT_GUARANTOR_APPLICATION_FORM_SUBMIT = 'Guarantor Application Form Submitted';
export const ANALYTICS_EVENT_SUNROOM_CLUB_PAID = 'Sunroom Select Paid';
export const ANALYTICS_EVENT_SUNROOM_CLUB_FORM_SUBMITTED = 'Sunroom Select Form Submitted';
export const ANALYTICS_EVENT_SUNROOM_CLUB_TOAST_CTA_CLICK = 'Sunroom Select Toast CTA Click';
export const ANALYTICS_EVENT_TOUR_RESCHEDULE_BUTTON_CLICK = 'Tour Reschedule CTA Click';
export const ANALYTICS_EVENT_TOUR_RESCHEDULE_LINK_CLICK = 'Tour Reschedule Blue Link Click';
export const ANALYTICS_EVENT_PREQUAL_COMPLETED = 'Prequal Completed';
export const ANALYTICS_EVENT_PREQUAL_COMPLETED_REQUEST_TOUR_PROMPT_NO_IMAGE = 'Prequal Completed Request Tour Page Prompt No Image'; // eslint-disable-line max-len
export const ANALYTICS_EVENT_PREQUAL_COMPLETED_REQUEST_TOUR_PROMPT_WITH_LISTING_IMAGE = 'Prequal Completed Request Tour Page Prompt With Listing Image'; // eslint-disable-line max-len
export const ANALYTICS_EVENT_PREQUAL_COMPLETED_REQUEST_TOUR_PROMPT_OPT_OUT = 'Prequal Completed Request Tour Page Prompt Opt Out'; // eslint-disable-line max-len
export const ANALYTICS_EVENT_PREQUAL_CTA_CLICK = 'Prequal CTA Click';
export const ANALYTICS_EVENT_FEED_CHANGE_FILTERS_CLICK = 'Feed Change Filters Click';
export const ANALYTICS_EVENT_FEED_CATEGORY_VIEW_ALL_CLICK = 'Feed Category View All Click';
export const ANALYTICS_EVENT_FEED_CATEGORY_CHANGE_FILTERS_CLICK = 'Feed Category Change Filters Click';
export const ANALYTICS_EVENT_FEED_CATEGORY_CHANGE_QUALIFICATIONS_CLICK = 'Feed Category Change Qualifications Click'; // eslint-disable-line max-len
export const ANALYTICS_EVENT_ONLINE_APP_REQUESTED = 'Online App Requested';
export const ANALYTICS_EVENT_CUSTOMER_IO_WEBHOOK_EVENT = 'Customer.io Webhook Event';
export const ANALYTICS_EVENT_SUNROOM_SMS_SENT = 'Sunroom SMS Sent';
export const ANALYTICS_EVENT_RENTER_SMS_SENT = 'Renter SMS Sent';
export const ANALYTICS_EVENT_EXTERNAL_AGENT_TOUR_REQUESTED = 'External Agent Tour Requested';
export const ANALYTICS_EVENT_AGENT_TOUR_REQUESTED = 'Agent Tour Requested';
export const ANALYTICS_EVENT_AGENT_FIRST_TOUR_REQUESTED = 'Agent First Tour Requested';
export const ANALYTICS_EVENT_SHOWING_ADDED_TO_AGENT_TOUR = 'Showing Added To Agent Tour';
export const ANALYTICS_EVENT_SHOWING_REMOVED_FROM_AGENT_TOUR = 'Showing Removed From Agent Tour';
export const ANALYTICS_EVENT_AGENT_TOUR_CONFIRMED = 'Agent Tour Confirmed';
export const ANALYTICS_EVENT_AGENT_SHOWING_COMPLETED = 'Agent Showing Completed';
export const ANALYTICS_EVENT_AGENT_SHOWING_CANCELED = 'Agent Showing Canceled';
export const ANALYTICS_EVENT_AGENT_SHOWING_FAILED = 'Agent Showing Failed';
export const ANALYTICS_EVENT_AGENT_TOUR_CANCELED = 'Agent Tour Canceled';
export const ANALYTICS_EVENT_AGENT_TOUR_COMPLETED = 'Agent Tour Completed';
export const ANALYTICS_EVENT_AGENT_TOUR_FAILED = 'Agent Tour Failed';
export const ANALYTICS_EVENT_LOCATOR_TOUR_STARTED = 'Locator Tour Started';
export const ANALYTICS_EVENT_LOCATOR_TOUR_COMPLETED = 'Locator Tour Completed';
export const ANALYTICS_EVENT_LOCATOR_SHOWING_STARTED = 'Locator Showing Started';
export const ANALYTICS_EVENT_LOCATOR_SHOWING_COMPLETED = 'Locator Showing Completed';
export const ANALYTICS_EVENT_SELF_TOUR_INITIATED = 'Self Tour Initiated';
export const ANALYTICS_EVENT_SELF_TOUR_COMPLETED = 'Self Tour Completed';
export const ANALYTICS_EVENT_GATE_ACCESS_SUPPORT_CALLED = 'Support for Gate Access Called';
export const ANALYTICS_EVENT_CODEBOX_SUPPORT_CALLED = 'Support for Codebox Called';
export const ANALYTICS_EVENT_DOOR_ACCESS_SUPPORT_CALLED = 'Support for Door Access Called';
export const ANALYTICS_EVENT_SUPRA_TOUR_COMPLETED = 'Supra Tour Completed';
export const ANALYTICS_EVENT_AGENT_TOUR_RESCHEDULED = 'Agent Tour Rescheduled';
export const ANALYTICS_EVENT_AGENT_TOUR_SHOWING_CONFIRMED = 'Agent Tour Showing Confirmed';
export const ANALYTICS_EVENT_CTA_CLICKED = 'CTA Clicked';
export const ANALYTICS_EVENT_SIGNUP_FUNNEL_STEP_COMPLETED = 'Signup Funnel Step Completed';
export const ANALYTICS_EVENT_SIGNUP_FUNNEL_COMPLETED = 'Signup Funnel Completed';
export const ANALYTICS_EVENT_SIGNED_IN = 'Signed In';
export const ANALYTICS_EVENT_SIGNED_OUT = 'Signed Out';
export const ANALYTICS_EVENT_BLUE_DOT_MAP_CLICKED = 'Blue Dot Map Clicked';
export const ANALYTICS_EVENT_ACCOUNT_CREATED = 'Account Created';
export const ANALYTICS_EVENT_LISTING_CATEGORY_VIEWED = 'Listing Category Viewed';
export const ANALYTICS_EVENT_LISTING_VIEWED = 'Listing Viewed';
export const ANALYTICS_EVENT_LISTING_WITHDRAWN = 'Listing Withdrawn';
export const ANALYTICS_EVENT_APPLICATION_STEP_COMPLETED = 'Application Step Completed';
export const ANALYTICS_EVENT_PREQUAL_STEP_COMPLETED = 'Prequal Step Completed';
export const ANALYTICS_EVENT_APPLICATION_COMPLETED = 'Application Completed';
export const ANALYTICS_EVENT_APPLICATION_ACCEPTED = 'Application Accepted';
export const ANALYTICS_EVENT_APPLICATION_REJECTED = 'Application Rejected';
export const ANALYTICS_EVENT_HOUSEHOLD_APPLICATION_COMPLETED = 'Household Application Completed';
export const ANALYTICS_EVENT_HOUSEHOLD_APPLICATION_ACCEPTED = 'Household Application Accepted';
export const ANALYTICS_EVENT_APPLICATION_FEE_PAID = 'Application Fee Paid';
export const ANALYTICS_EVENT_LEASE_SIGNED = 'Lease Signed';
export const ANALYTICS_EVENT_LISTING_SHARE_CLICKED = 'Listing Share Clicked';
export const ANALYTICS_EVENT_MAP_RELOADED = 'Map Reloaded';
export const ANALYTICS_EVENT_CONTACT_BUTTON_CLICKED = 'Contact Button Clicked';
export const ANALYTICS_EVENT_CALL_BUTTON_CLICKED = 'Call Button Clicked';
export const ANALYTICS_EVENT_TEXT_BUTTON_CLICKED = 'Text Button Clicked';
export const ANALYTICS_EVENT_ROOMMATE_REMOVED_FROM_HOUSEHOLD = 'Roommate Removed From Household';
export const ANALYTICS_EVENT_GUARANTOR_REMOVED_FROM_HOUSEHOLD = 'Guarantor Removed From Household';
export const ANALYTICS_EVENT_BUYERS_SIDE_APPLICATION_REQUESTED = 'Buyers Side Application Requested';
export const ANALYTICS_EVENT_3D_TOUR_OPENED = '3D Tour Opened';
export const ANALYTICS_EVENT_3D_TOUR_CLOSED = '3D Tour Closed';
export const ANALYTICS_EVENT_PARTNER_CALLED = 'Partner Called';
export const ANALYTICS_EVENT_BACKGROUND_CREDIT_CHECKED = 'Background and Credit Checked';
export const ANALYTICS_EVENT_SUNROOM_LISTING_MADE_ACTIVE = 'Sunroom Listing Made Active';
export const ANALYTICS_EVENT_START_PAGE_VISITED = 'Start Page Visited';
export const ANALYTICS_EVENT_PARTNER_SOLD = 'Partner Sold';
export const ANALYTICS_EVENT_EMPLOYER_VERIFICATION_SENT = 'Employer Verification Sent';
export const ANALYTICS_EVENT_LANDLORD_VERIFICATION_SENT = 'Landlord Verification Sent';
export const ANALYTICS_EVENT_AGENT_PARTNER_DASHBOARD_SEE_HOW_IT_WORKS_LINK_CLICKED = 'Agent Partner Dashboard How It Works Link Clicked'; // eslint-disable-line max-len
export const ANALYTICS_EVENT_MARKET_PROPERTY_SUBMITTED = 'Market Property Submitted';
export const ANALYTICS_EVENT_MARKET_PROPERTY_SUBMITTED_BY_OWNER = 'Market Property Submitted By Owner';
export const ANALYTICS_EVENT_PARTNER_USER_CREATED = 'Partner User Created';
export const ANALYTICS_EVENT_PARTNER_LEAD_CREATED = 'Partner Lead Created';
export const ANALYTICS_EVENT_PARTNER_LISTING_RENEWAL_DRIP_STARTED = 'Partner Listing Renewal Drip Started';
export const ANALYTICS_EVENT_PARTNER_LISTING_RENEWAL_EMAILS_STOPPED = 'Partner Listing Renewal Emails Stopped'; // eslint-disable-line max-len

// Sendgrid
export const ANALYTICS_EVENT_EMAIL_DELIVERED = 'Email Delivered';
export const ANALYTICS_EVENT_EMAIL_OPENED = 'Email Opened';
export const ANALYTICS_EVENT_EMAIL_CLICKED = 'Email Clicked';
export const ANALYTICS_EVENT_EMAIL_BOUNCED = 'Email Bounced';
export const ANALYTICS_EVENT_EMAIL_DROPPED = 'Email Dropped';
export const ANALYTICS_EVENT_EMAIL_SPAM_REPORT = 'Email Spam Report';
export const ANALYTICS_EVENT_EMAIL_UNSUBSCRIBE = 'Email Unsubscribe';
export const ANALYTICS_EVENT_EMAIL_GROUP_UNSUBSCRIBE = 'Email Group Unsubscribe';
export const ANALYTICS_EVENT_EMAIL_GROUP_RESUBSCRIBE = 'Email Group Resubscribe';

// DEPRECATED
/* eslint-disable no-unused-vars */
const ANALYTICS_EVENT_TOUR_REQUEST_EMAIL_SENT = 'Tour Request Email Sent';
const ANALYTICS_EVENT_SCHEDULE_TOUR = 'Schedule Tour';
const ANALYTICS_EVENT_SCHEDULE_FIRST_TOUR = 'Schedule First Tour';
const ANALYTICS_EVENT_PAGE_LOAD = 'Page Load';
const ANALYTICS_EVENT_MAP_SEARCH_MARKER_CLICK = 'Map Search Clicked Pin';
const ANALYTICS_EVENT_FEED_CATEGORY_LISTING_CLICK = 'Feed Category Listing Click';
const ANALYTICS_EVENT_SIGNUP = 'Signup';
const ANALYTICS_EVENT_LOGIN = 'Login';
const ANALYTICS_EVENT_LOGOUT = 'Logout';
const ANALYTICS_EVENT_USER_ADDRESS_SEARCH = 'User Address Search';
const ANALYTICS_EVENT_BOOKMARK_ADD = 'Bookmark Add';
const ANALYTICS_EVENT_RENTER_APPLICATION_FIELD_UPDATE = 'Renter Application Field Updated';
const ANALYTICS_EVENT_RENTER_APPLICATION_FORM_SUBMIT = 'Renter Application Form Submitted';
const ANALYTICS_EVENT_APPLICATION_PAID = 'Application Paid';
const ANALYTICS_EVENT_SEARCH_FILTERS_UPDATE = 'Search Filters Update';
/* eslint-enable no-unused-vars */
